import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import useSWR from "swr";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
const CategoryNameInput = (params) => {
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "megaHeadS?head_id=" + params.id
  );
  const [name, setname] = useState();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <Box
      component="form"
      method="post"
      action={process.env.REACT_APP_DEF_URL + "menusingleupdate.php"}
      sx={{
        "& > :not(style)": {
          m: 1,
          width: "80%",
          display: "flex",
          alignItems: "center",
        },
      }}
      noValidate
      autoComplete="off"
      encType="multipart/form-data"
    >
      <input type="hidden" value={params.id} name="head_id" />
      <TextField
        id="outlined-basics"
        label="Başlık"
        variant={"outlined"}
        fullWidth
        name="head_name"
        onChange={(e) => setname(e.target.value)}
        defaultValue={data.head_name}
        value={name}
      />
      <Button variant="outlined" type="submit">
        Güncelle
      </Button>
      <Button variant="outlined" onClick={handleClickOpen} color="error">
        Delete
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "megaHeadDelete"}
      >
        <input type="hidden" value={data.head_id} name="head_id"/>
        <DialogTitle id="alert-dialog-title">
          {"Silmek İstediğinize Emin Misiniz?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bu işleme onay verdiğinizde, seçili öğeler kalıcı olarak silinir ve
            hiçbir şekilde geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>İptal</Button>
          <Button onClick={handleClose} autoFocus color="error" type="submit">
            Onayla
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CategoryNameInput;
